import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { useConfigUI } from '../../context'
import { useDeletePlant } from '../../hooks/plants'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
  /** The plant's name, so the confirmation names what it is about to remove. */
  name?: string
  onSuccess?: () => void
}

const DeletePlantModal = ({
  id,
  interfaceId,
  name,
  onSuccess,
}: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()

  const { mutate: deleteModal, isLoading: loadingDeletePlant } =
    useDeletePlant()

  const handleDeleteSite = () => {
    if (!id) return
    if (!interfaceId) return
    deleteModal(
      { interfaceId, id },
      {
        onSuccess: () => {
          onSuccess && onSuccess()
        },
      },
    )
  }

  return (
    <ConfirmDeleteModalUI
      title={t('DeletePlants')}
      name={name}
      text={t('plantDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteSite}
      isLoading={loadingDeletePlant}
    />
  )
}

export default DeletePlantModal
